import {Flag} from 'platform/components';
import {Show} from 'platform/foundation';

import i18n from '@dms/i18n';

import {isBelowPriorityRating} from '../../model/auctionView';
import type {AuctionOffer} from '../../model/auctionView.types';

interface LowRatingFlagProps {
  offer: AuctionOffer;
  testId: string;
}

export function LowRatingFlag(props: LowRatingFlagProps) {
  return (
    <Show when={isBelowPriorityRating(props.offer)}>
      <Flag
        label={i18n.t('entity.auction.offers.lowRating', {
          defaultValue: 'Below 3★ · lost priority',
        })}
        colorScheme="orange"
        size="small"
        isSubtle
        data-testid={props.testId}
      />
    </Show>
  );
}
